import type * as ents from '@attain-apps/entities'
import { formatDate, formatDistanceToNow } from 'date-fns'

// TODO: maybe use ents.core.common.DateWithUtcOffset.format and somehow present
// time zones
const RELATIVE_DATE_FORMATTER: State['extractFormattedDate'] = response =>
  formatDistanceToNow(response.submittedOn.date, { addSuffix: true })
const ABSOLUTE_DATE_FORMATTER: State['extractFormattedDate'] = response =>
  formatDate(response.submittedOn.date, 'EEEE — MMMM d, yyyy')

export interface State {
  readonly extractFormattedDate: (
    response: ents.core.summit.CheckIn.Response,
  ) => string
}
export namespace State {
  export const INITIAL: Readonly<State> = {
    extractFormattedDate: RELATIVE_DATE_FORMATTER,
  }

  /**
   * Toggles {@link State.extractFormattedDate}
   */
  export function toggleDateFormat(state: State): State {
    return {
      ...state,
      extractFormattedDate:
        state.extractFormattedDate === RELATIVE_DATE_FORMATTER
          ? ABSOLUTE_DATE_FORMATTER
          : RELATIVE_DATE_FORMATTER,
    }
  }
}
